module.exports = __webpack_public_path__ + "img/01_sub_uk.173939db.svg";